// Forma do endereço na aplicação.
//
// Vive fora do componente para que tipos e valor inicial possam ser usados por
// telas que ainda não renderizam o bloco — e para manter o componente
// exportando apenas o componente.

export interface Endereco {
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  /** Descrição livre sobre o local. Opcional: nem todo cadastro pede. */
  comentario?: string;
}

export const ENDERECO_VAZIO: Endereco = {
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
  comentario: '',
};
